// Pricing 섹션 플랜 데이터 (Figma node 2921:12973 기준)
// 카피는 entry-form 컨벤션에 따라 컴포넌트 레이어에 하드코딩.

/** 기능 한 줄. note 가 있으면 회색 보조 텍스트(예: "(2만원/채널, 별도 구매)") */
export type PlanFeature = {
  /** 기능 본문. **로 감싸면 SemiBold 강조됨 (예: "**모든 채널** 커스텀 수집") */
  label: string
  /** 본문 뒤에 붙는 회색 보조 카피 */
  note?: string
  /** 별도 구매 등 "비활성" 톤(회색 체크 + 구분선 위) 여부 */
  isMuted?: boolean
}

export type Plan = {
  id: string
  /** 플랜명 (예: 베이직) */
  name: string
  /** 가격 본문 (예: 49,900원, 30만원~) */
  price: string
  /** 가격 단위 (예: /월) */
  pricePeriod: string
  /** 플랜 한 줄 설명 */
  description: string
  /** 파란 pill 로 강조되는 대표 기능 (모든 플랜 공통: 리뷰드 B2C 노출) */
  highlightFeature: string
  /** 체크리스트 기능 */
  features: PlanFeature[]
  /** 강조(추천) 플랜 — 그라데이션 배경 + 진한 보더 */
  isFeatured?: boolean
  /** 가격 옆 작은 뱃지 (예: "한달 무료 혜택!") */
  badge?: string
}

export const PLANS: Plan[] = [
  {
    id: "basic",
    name: "베이직",
    price: "49,900원",
    pricePeriod: "/월",
    description: "리뷰 관리를 처음 시작하는 병원을 위한 입문 플랜",
    highlightFeature: "리뷰드(Review:ed) B2C 플랫폼 노출",
    badge: "한달 무료 혜택!",
    features: [
      { label: "지도앱 리뷰 수집 (네이버·구글·카카오)" },
      { label: "신규 리뷰 자동 알림" },
      { label: "부정 리뷰 자동 모니터링" },
      { label: "AI 자동 답변 생성 및 등록" },
      { label: "플랫폼 채널", note: "(2만원/채널, 별도 구매)", isMuted: true },
      { label: "카페·커뮤니티·유튜브", note: "(3만원/채널, 별도 구매)", isMuted: true },
      { label: "플랫폼 리뷰 삭제 신청", note: "(5만원/건, 별도 구매)", isMuted: true },
    ],
  },
  {
    id: "standard",
    name: "스탠다드",
    price: "99,900원",
    pricePeriod: "/월",
    description: "지도앱 3채널 + 플랫폼 2채널 + 카페·커뮤니티·유튜브 중 1채널 선택 포함",
    highlightFeature: "리뷰드(Review:ed) B2C 플랫폼 노출",
    features: [
      { label: "베이직 기능 모두 포함" },
      { label: "플랫폼 채널 2개 포함", note: "(추가 2만원/채널)" },
      { label: "카페·커뮤니티·유튜브 1채널 선택 포함", note: "(추가 3만원/채널)" },
      { label: "플랫폼 리뷰 삭제 신청", note: "(5만원/건)" },
    ],
  },
  {
    id: "enterprise",
    name: "엔터프라이즈",
    price: "30만원~",
    pricePeriod: "/월",
    description: "대형 병원·체인 클리닉을 위한 맞춤 설계 플랜",
    highlightFeature: "리뷰드(Review:ed) B2C 플랫폼 노출",
    isFeatured: true,
    features: [
      { label: "**모든 채널** 커스텀 수집" },
      { label: "**플랫폼·커뮤니티·유튜브·당근 전체**" },
      { label: "플랫폼 **리뷰 삭제 신청 10건** 포함" },
      { label: "검색 대상 **리뷰 범위 커스텀**" },
      { label: "**전담 매니저 + 전용 채팅창** 운영" },
      { label: "리뷰드(Reviewd) B2C 채널 통한 **플랫폼 맞춤 설계**" },
    ],
  },
]
